module.exports = __webpack_public_path__ + "static/media/CodeAirBody.abf02fe7.glb";